<template>
	<div class="d-flex align-items-center mt-4">
		<button
			v-if="masterStore.state.activeComponent !== 'table'"
			type="button"
			@click="masterStore.methods.changeComponent('table')"
			class="circle-btn bg-yellow me-3 fs-5"
		>
			<i class="bi bi-caret-left-fill text-gray"></i>
			
		</button>

		<span
			:class="`text-medium text-yellow cursor-pointer me-2 fs-3 `"
			@click="masterStore.methods.changeComponent('table'), $emit('btnClick')"
			>{{ name }}</span
		>
		<span
			v-if="masterStore.state.activeComponent !== 'table'"
			class="text-medium text-dark me-2"
		>
			<i class="bi bi-caret-left-fill text-gray fs-5"></i>
		</span>
		<span
			v-if="masterStore.state.activeComponent !== 'table'"
			:class="`fs-3 text-capitalize  text-yellow`"
		>
			{{ masterStore.state.activeComponent }}
		</span>
		<button
			v-if="masterStore.state.activeComponent === 'table'"
			type="button"
			@click="masterStore.methods.changeComponent('create')"
			class="btn bg-blue text-white custom-rounded-15 px-5 py-1 btn-sm fs-6 ms-auto"
		>
			Add New {{ name }}
		</button>
	</div>
</template>

<script>
	import { inject } from "vue";
	export default {
		name: "MasterBreadCrumb",
		props: {
			name: {
				type: String,
				required: true,
			},
		},
		emits: ["btnClick"],
		setup: () => {
			const masterStore = inject("masterStore");

			return {
				masterStore,
			};
		},
	};
</script>
<style scoped>
.circle-btn{
	border-radius: 25px;
	border: 1px transparent;
}
/* .bi-caret-left-fill::before {
	color: #fff;
} */
</style>

